// My box Status
export const REQUEST_MY_BOX = 'REQUEST_MY_BOX';
export const REQUEST_MY_BOX_SUCCESS = 'REQUEST_MY_BOX_SUCCESS';
export const REQUEST_MY_BOX_FAIL = 'REQUEST_MY_BOX_FAIL';
